import { Link, useParams } from 'react-router-dom';
import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api';
import StorefrontPreview from './StorefrontPreview';
import { storefrontToPayload } from '../../utils/storefront';

export default function PublicStorefrontPage() {
  const { username, projectSlug, bookSlug } = useParams();
  const storefront = useQuery(
    api.storefronts.getPublicByPath,
    username && projectSlug && bookSlug ? { username, projectSlug, bookSlug } : 'skip',
  );

  if (storefront === undefined) {
    return <div className="sf-public-shell"><div className="sf-public-loading">Loading storefront...</div></div>;
  }

  if (!storefront) {
    return (
      <div className="sf-public-shell">
        <div className="sf-public-empty">
          <h1>Storefront unavailable</h1>
          <p>This book page is not published or the link is incorrect.</p>
          <Link className="btn btn-primary" to="/">Open Share-Pen</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="sf-public-shell">
      <StorefrontPreview payload={storefrontToPayload(storefront)} publicMode />
    </div>
  );
}
